module.exports = __webpack_public_path__ + "static/media/zxJyPie.192d7a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zxJyPie.png
// module id = 1891
// module chunks = 0 1